import { render, staticRenderFns } from "./Sidebar-item.vue?vue&type=template&id=258c59e9&scoped=true&"
import script from "./Sidebar-item.vue?vue&type=script&lang=js&"
export * from "./Sidebar-item.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar-item.vue?vue&type=style&index=0&id=258c59e9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258c59e9",
  null
  
)

export default component.exports